import { render, staticRenderFns } from "./PartnershipGrantCard.vue?vue&type=template&id=5085461e"
import script from "./PartnershipGrantCard.vue?vue&type=script&lang=js"
export * from "./PartnershipGrantCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports